import { Header, Button, AppHeader, LogoHp, Modal, ButtonGroup, IconLogOut } from "@veneer/core";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateAuthentication } from "../../features/auth/authenticationSlice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";


export default function Navbar() {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const publicUrl = process.env.PUBLIC_URL;
  const navigate = useNavigate();

  const [showModalLogOut, setShowModalLogOut] = useState(false);


  const onLogOut = () => {
    setShowModalLogOut(false);
    dispatch(updateAuthentication(false));
    navigate(process.env.REACT_APP_AUTH_PROVIDER + `oauth/logout?post_logout_redirect_uri=${process.env.REACT_APP_URL_REDIRECT}&state=${sessionStorage.getItem("hppm-state")}`);
  }

  return (
    <div>
      <Header
        leadingArea={
          <AppHeader
            appName="HP POS Manager"
            logo={<LogoHp appearance="multicolor" />}
            logoUrl={publicUrl}
            style={{ marginLeft: '10px' }}
          />
        }
        appearance="dropShadow"
        position="fixed"
        responsiveLayout="singleRow"
        trailingArea={
          <div style={{ margin: '20px' }}>
            <Button
              small
              onClick={() => setShowModalLogOut(true)}
            >
              {t("header.logout")}
            </Button>
          </div>

        }
      />

      <div style={{ position: 'relative' }}>
        <Modal
          align="center"
          id="modalLogOut"
          show={showModalLogOut}
          closeButton
          onClose={() => setShowModalLogOut(false)}
          footer={(
            <ButtonGroup className="logOutButtongrouop" style={{justifyContent: 'center'}}>
              <Button onClick={onLogOut}>{t("header.confirm")}</Button>
              <Button onClick={() => setShowModalLogOut(false)} appearance="secondary">{t("header.cancel")}</Button>
            </ButtonGroup>
          )}
          title={t("header.logout")}
        >
          <IconLogOut size={120} />
          <br />
          <b>{t("header.msgLogout")}</b>
        </Modal>
      </div>
    </div>
  );
}